// === Task 25 === Floating workflow FAB.
// Bottom-right button rendered over the editor canvas. Visible ONLY when the
// currently selected box is an InteractivePlugin and that plugin has at least
// one item in its toolbar state. Click dispatches openInteractivityStudio({
// tab: "workflow" }) to open the unified Interactivity Studio modal on its
// Workflow tab.
import React from "react";
import i18n from "i18next";
import { connect } from "react-redux";
import { openInteractivityStudio } from "../../../common/actions";
import "./WorkflowFAB.scss";

export function WorkflowFAB({ visible, itemCount, onOpen }) {
  if (!visible) return null;
  return (
    <button
      type="button"
      className="workflow-fab"
      onClick={onOpen}
      aria-label={i18n.t("Workflow.fab", { defaultValue: "Open workflow" })}
      title={i18n.t("Workflow.fab_tooltip", { defaultValue: "Open workflow editor" })}
    >
      <span className="workflow-fab__icon" aria-hidden="true">
        ⚡
      </span>
      <span className="workflow-fab__chip">
        {i18n.t("Workflow.fab_chip", { defaultValue: "workflow" })} · {itemCount}
      </span>
    </button>
  );
}

const mapStateToProps = (state) => {
  // undoGroup is wrapped by redux-undo, so the live slice is at .present.
  // Defensive read because some tests/utilities may pass an already-unwrapped
  // shape (or no undoGroup at all when running outside the editor).
  const present = (state.undoGroup && state.undoGroup.present) || state.undoGroup || {};
  const selectedBoxId = present.boxSelected;
  const hasSelection =
    selectedBoxId !== undefined && selectedBoxId !== null && selectedBoxId !== -1;
  const tb =
    hasSelection && present.pluginToolbarsById ? present.pluginToolbarsById[selectedBoxId] : null;
  const isInteractive = !!(tb && tb.pluginId === "InteractivePlugin");
  const items = (tb && tb.state && Array.isArray(tb.state.items) && tb.state.items) || [];
  return {
    visible: isInteractive && items.length > 0,
    itemCount: items.length,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onOpen: () => dispatch(openInteractivityStudio({ tab: "workflow" })),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowFAB);
// === /Task 25 ===
